import React from 'react';
import { FiFacebook, FiLinkedin, FiChevronRight, FiPhone, FiYoutube } from "react-icons/fi";

const HeaderTopBar = () => {
    return (
        <div className="header-top-bar">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="header-left">
                            <p><a href="#">Let's Grow your Life, Business and Income <FiChevronRight /></a></p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="header-right">
                            <div className="address-content">
                                {/* <p><FiMapPin /><span>Rajshahi, BD</span></p> */}
                                <p><FiPhone /><span><a href="#">+88 01724902455</a></span></p>
                            </div>
                            <div className="social-icon-wrapper">
                                <ul className="social-icon social-default icon-naked">
                                    <li><a target='BLANK' href="https://www.facebook.com/share/16qKp424qd/?mibextid=wwXIfr"><FiFacebook /></a></li>
                                    <li><a target='BLANK' href="https://youtube.com/@passionateworld8122?si=-0yD6TMI4oaR6NJQ"><FiYoutube /></a></li>
                                    {/* <li><Link to="instagram.com"><FiInstagram /></Link></li> */}
                                    <li><a target='BLANK' href="https://www.linkedin.com/in/jahid-hasan-5932131b8/"><FiLinkedin /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopBar;
